import { Injectable } from '@angular/core';
import { MimeType } from '@data-terminal/shared-models/mime-type.enum';
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root',
})
export class FileDownloaderService {
    public download(data: string, fileName: string, mimeType: MimeType): void {
        const blob: Blob = new Blob([data], { type: mimeType });

        this.saveAs(blob, fileName);
    }

    protected saveAs(blob: Blob, fileName: string): void {
        saveAs(blob, fileName);
    }
}
